import { createRoot } from 'react-dom/client';
import './style.scss';
import Style from './Components/Common/Style';
import ThemeSwitch from './Components/Common/themes/ThemeSwitch/ThemeSwitch';

document.addEventListener('DOMContentLoaded', () => {
	const blockEls = document.querySelectorAll('.wp-block-faa-faq-and-answers');

	blockEls.forEach(blockEl => {
		const attributes = JSON.parse(blockEl.dataset.attributes);

		const isPremium = scdIsPipeChecker;
		const activeTheme = attributes?.theme || 'default';
		const proThemes = ['themeFive', 'themeSeven', 'themeEight'];
		const showOverlay = !isPremium && proThemes.includes(activeTheme);

		const siteLocation = `/wp-admin/edit.php?post_type=faq_cpt&page=faq_Dashboard#/pricing`;

		createRoot(blockEl).render(
			<>
				<Style attributes={attributes} id={blockEl.id} />
				<div className='faq-main-wrapper'>
					<ThemeSwitch attributes={attributes} setAttributes={() => { }} />
					{showOverlay && (
						<div className="scd-pro-overlay">
							<div className="overlay-inner">
								<h3>🚫 Premium Theme</h3>
								<p>This theme requires a Pro license.</p>
								<a href={siteLocation} rel="noreferrer" target="_blank" className="upgrade-btn">
									Upgrade Now
								</a>
							</div>
						</div>
					)}
				</div>
			</>
		);

		blockEl.removeAttribute('data-attributes');
	});
});
